import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LOGO } from '../../services/ImageService';
interface childrenProps {
  isOpen: boolean
}
const SideNav: React.FC<childrenProps> = ({ isOpen }) => {

  const listItems = [
    {
      id: 1,
      label: "Dashboard",
      icon: "fa-tachometer",
      link: "/auth/",
    },
    // {
    //   id: 8,
    //   label: "Projects",
    //   icon: "fa-user",
    //   link: "/auth/projects",
    // },
    {
      id:9,
      label:"Access Keys",
      icon:"fa-user",
      link:"/auth/access-keys"
    },
    {
      id: 8,
      label: "DSC",
      icon: "fa-user",
      link: "/auth/dsc",
    },
    {
      id: 8,
      label: "Digital Sign",
      icon: "fa-user",
      link: "/auth/signtest",
    },
    {
      id: 8,
      label: "Users",
      icon: "fa-user",
      link: "/auth/users",
    },
    {
      id: 9,
      label: "Roles",
      icon: " fa-users",
      link: "/auth/roles",
    },
  ]
  const navigate = useNavigate();
  const location = useLocation();
  const navigateLink = (index: any) => {
    navigate(index);
  };


  return (
    <div
      className={`smart-sidenav ${isOpen ? "expanded" : ""}`}
    >
      {/* Brand Logo */}
      <div className="brand-logo">
        <img src={LOGO} alt="Brand Logo" />
      </div>
      {listItems.map((item, index) => {
        return (
          <a key={`nav_link_${index}`} href="#" onClick={() => navigateLink(item.link)}
            className={location.pathname === item.link ? "sidenav-link sidenav-active-link" : "sidenav-link"}>
            <i className={`icon fa ${item.icon} `}></i>
            <span className="link-text">{item.label}</span>
          </a>
        )
      })}
    </div>
  );
}
export default SideNav
